module.exports = __webpack_public_path__ + "static/media/bg-examination-results.63e06e9a.png";